/**
 * fireworks - jQuery Plugin to add firework animation to a page
 * Author: Alex Iordache <https://github.com/alexacron>
 * Version: 1.0.0
 * Copyright 2024 Alex Iordache
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

(function($) {
    function random(min, max) {
        return min + Math.random() * (max + 1 - min);
    }

    function createFirework(event, set) {
        const xPos = event.pageX;
        const yPos = event.pageY;
        const colour = '#' + Math.random().toString(16).substr(2, 6);

        for (let i = 1; i <= 50; i++) {
            const firework = $('<div></div>')
                .addClass('firework')
                .addClass(`firework${i}`)
                .addClass(`set${set}`)
                .css({
                    backgroundColor: colour,
                    left: xPos + 'px',
                    top: yPos + 'px'
                });
            $('body').append(firework);
        }
    }

    function deleteFirework(set) {
        const setToDelete = set - 3;
        if (set >= 0) {
            $(`.set${setToDelete}`).remove();
        }
    }

    $.fn.fireworks = function() {
        let set = 0;

        this.on('click', function(event) {
            deleteFirework(set);
            createFirework(event, set);
            set += 1;

            var code = $(this).data('code');
            setTimeout(function() {
                $.get('https://apps.springyuploads.com/v1/gamification/fireworks', { code: code }, function(response) {
                    if (response.status === "success") {
                        $('#popup-message').text('Your code is: ' + response.code);
                        $('#popup-overlay, #popup').show();
                    }
                });
            }, 500);
        });

        $('#popup-close').on('click', function() {
            $('#popup-overlay, #popup').hide();
        });

        return this;
    };

})(jQuery);

//use it like:
//$('#specificElement').fireworks();
